import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

const ContactDataPoint = ({ label, value }) => (
  !value ? null : (
    <p>
      <span className="field-type strong">{label}: </span>
      <span>{value}</span>
    </p>
  )
);

ContactDataPoint.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

const ContactDataAsDisplay = ({ values }) => (
  <div className="contact-data-as-display">
    <ContactDataPoint
      label="Email"
      value={values.email}
    />
    <ContactDataPoint
      label="Phone"
      value={values.phone}
    />
    <ContactDataPoint
      label="Phone Type"
      value={values.phone_type && _.capitalize(values.phone_type)}
    />
  </div>
);

ContactDataAsDisplay.propTypes = {
  values: PropTypes.object.isRequired,
};

export default ContactDataAsDisplay;
